import { Product, Review, WithContext } from 'schema-dts'

import { withoutQuot } from '@/shared/lib/utils/string/withoutQuot'

export type ProductSchemaReview = {
	author: string
	createdAt: string
	rating: number
	comment: string
}

export interface ProductSchemaProps {
	productData: {
		code: string
		title: string
		description: string
		images: string[]
		article: string
		price: number
		brand: string
		isInStock: boolean
	}
	category: string
	reviews?: ProductSchemaReview[]
}

const getSchemaText = (value?: string | number | null): string => withoutQuot(String(value ?? ''))

export const ProductSchema = (props: ProductSchemaProps): WithContext<Product> => {
	const { productData, category, reviews = [] } = props
	const { code, title, description, images, article, price, brand, isInStock } = productData
	const reviewItems: Review[] = reviews
		.filter(review => review.author && review.comment && review.rating)
		.map(review => ({
			'@type': 'Review',
			name: getSchemaText(title),
			author: {
				'@type': 'Person',
				name: getSchemaText(review.author)
			},
			datePublished: review.createdAt,
			reviewBody: getSchemaText(review.comment),
			reviewRating: {
				'@type': 'Rating',
				ratingValue: review.rating,
				bestRating: 5,
				worstRating: 1
			}
		}))

	return {
		'@context': 'https://schema.org',
		'@type': 'Product',
		url: `https://www.iport.ru/products/productID${code}/`,
		name: title,
		description: description,
		brand: {
			'@type': `Brand`,
			name: brand
		},
		image: images,
		mpn: article,
		category: category,
		offers: {
			'@type': `Offer`,
			url: `https://www.iport.ru/products/productID${code}/`,
			availability: isInStock ? `https://schema.org/InStock` : `https://schema.org/OutOfStock`,
			priceCurrency: `RUB`,
			...(isInStock && { price: price })
		},
		...(reviewItems.length ? { review: reviewItems } : {})
	}
}
